import {
  WSElement,
  WSIcon,
  WSIconName,
  WSInfoBox,
  WSInfoBoxProps
} from "@wingspanhq/fe-component-library";
import styles from "./index.module.scss";

export type QuoteProps = {
  icon?: WSIconName;
} & WSInfoBoxProps;

export const Quote: React.FC<QuoteProps> = ({ icon, ...props }) => (
  <WSElement className={styles.quote}>
    <WSIcon name={icon || "user"} size="L" />
    <WSInfoBox transparent {...props} />
  </WSElement>
);
